import ModalMultiPreview from "components/Common/ModalMultiPreview";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_AUDITION_STATUS,
  LIST_OPTION_AUDITION_STATUS,
} from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "reactstrap";
import AuditionImg from "../../../assets/images/Audition.png";

const AuditionInfoTab = ({ data }: any) => {
  const { t, i18n } = useTranslation();
  const [linkImage, setLinkImage] = useState<any>(null);
  const item = {
    auditionTitle: data?.audition?.title,
    createdAt: formatDateStringToKorea(data?.audition?.published_at),
    status: data?.audition?.status,
    thumbnail: data?.audition?.thumbnail_url,
    images: data?.audition?.image_urls,
    company: data?.company?.name,
    venue: data?.performance?.venue,
    field_category: Array.from(
      new Set(data?.audition?.role_groups?.map((i: any) => i?.field?.title))
    ),
    audition_startDate: formatDateStringToKorea(
      data?.audition?.application_start_date
    ),
    audition_endDate: formatDateStringToKorea(
      data?.audition?.application_end_date
    ),
    contactPhone: data?.audition?.contact_phone,
    contactEmail: data?.audition?.contact_email,
  };

  return (
    <div className="p-3">
      <Row className="mb-4">
        <Col md="4">
          <strong>{t('Audition Title')}</strong>
          <div>{item?.auditionTitle}</div>
        </Col>
        <Col md="4">
          <strong>{t('Created at')}</strong>
          <div>{item?.createdAt}</div>
        </Col>
        <Col md="4">
          <strong>{t('Status')}</strong>
          <div>
            <span
              className={`rounded-pill badge bg-${
                COLOR_AUDITION_STATUS[item?.status] || "secondary"
              }`}
            >
              {t(
                LIST_OPTION_AUDITION_STATUS?.find(
                  (i: any) => String(i?.value) === String(item?.status)
                )?.label || ""
              )}
            </span>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md="12">
          <strong>{t('Thumbnail')}</strong>
        </Col>
        <Col md="3" className="mt-2 mb-2">
          <div
            style={{ width: "90px" }}
            className="cursor-pointer"
            onClick={() => {
              setLinkImage(item?.thumbnail ?? AuditionImg);
              document.body.className = "modal-open_img";
            }}
          >
            <img
              src={item?.thumbnail ?? AuditionImg}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = AuditionImg;
              }}
              className="flex-shrink-0 rounded w-100"
              alt="thumbnail"
            />
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md="12">
          <strong>{t('Photo')}</strong>
        </Col>
        <div className="d-flex gap-3 flex-wrap">
          {item?.images?.map((i: any, index: any) => (
            <div key={i} className="mt-2 mb-2">
              <div
                style={{ width: "90px" }}
                className="cursor-pointer"
                onClick={() => {
                  setLinkImage(i ?? AuditionImg);
                  document.body.className = "modal-open_img";
                }}
              >
                <img
                  src={i ?? AuditionImg}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = AuditionImg;
                  }}
                  className="flex-shrink-0 rounded w-100"
                  alt="audition"
                />
              </div>
            </div>
          ))}
        </div>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <strong>{t('Company')}</strong>
        </Col>
        <Col md="9">{item?.company}</Col>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <strong>{t('Venue')}</strong>
        </Col>
        <Col md="9">{item?.venue}</Col>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <strong>{t('fieldCategories')}</strong>
        </Col>
        <Col md="9">{item?.field_category?.join(", ")}</Col>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <strong>{t('audition_start_date')}</strong>
        </Col>
        <Col md="3">{item?.audition_startDate}</Col>
        <Col md="3">
          <strong>{t('audition_end_date')}</strong>
        </Col>
        <Col md="3">{item?.audition_endDate}</Col>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <strong>{t('Contact Phone')}</strong>
        </Col>
        <Col md="3">{item?.contactPhone}</Col>
        <Col md="3">
          <strong>{t('Contact Email')}</strong>
        </Col>
        <Col md="3">{item?.contactEmail}</Col>
      </Row>

      <ModalPreview
        type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
        isOpen={!!linkImage}
        url={linkImage}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />

      <ModalMultiPreview
        isOpen={!!linkImage?.urls}
        urls={linkImage?.urls || []}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />
    </div>
  );
};

export default AuditionInfoTab;
